import React, { useState, useEffect } from "react";
import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import HomeLayout from "./HomeLayout";
import PrivacyPolicy from "./components/PrivacyPolicy";
import WelcomePage from "./components/WelcomePage";
import Pricing from './components/Pricing';
import TermsOfService from "./components/TermsOfService";
import ThankYou from "./components/ThankYou";
import { UserProvider } from "./components/UserContext";
import ProtectedRoute from './components/ProtectedRoute';

import "./App.css"; // Import the CSS file

// Amplify stuff
// import { Amplify } from 'aws-amplify';
// import { User } from "aws-cdk-lib/aws-iam";
// import awsconfig from './aws-exports';

// Amplify.configure(awsconfig);

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    document.title = isLoggedIn ? "Rocket Offer - Dashboard" : "Rocket Offer";
  }, [isLoggedIn]);

  const theme = createTheme({
    palette: {
      mode: isDarkMode ? "dark" : "light",
      primary: {
        main: isDarkMode ? "#1976d2" : "#1e88e5",
      },
    },
  });

  const toggleTheme = () => setIsDarkMode(!isDarkMode);
  const handleLoginToggle = () => setIsLoggedIn(!isLoggedIn);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <UserProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <HomeLayout
                  toggleTheme={toggleTheme}
                  isDarkMode={isDarkMode}
                  handleLoginToggle={handleLoginToggle}
                />
              }
            />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>

        </Router>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;